import type { StoreId } from "@KassaroAB/shared/types/ids";
import type {
  RestBulkUpsertProductOverlays,
  RestBulkUpsertProductOverlaysResponse,
  RestProductOverlayListItem,
} from "@KassaroAB/shared/types/productOverlay";
import { api } from "../utils/api";

export const getProductOverlaysApi = (
  storeId: StoreId,
): Promise<RestProductOverlayListItem[]> => {
  return api.get<RestProductOverlayListItem[]>(
    `stores/${storeId}/products/overlays`,
  );
};

export const bulkUpsertProductOverlaysApi = (
  storeId: StoreId,
  updates: RestBulkUpsertProductOverlays["updates"],
): Promise<RestBulkUpsertProductOverlaysResponse> => {
  return api.put<RestBulkUpsertProductOverlaysResponse>(
    `stores/${storeId}/products/overlays/bulk`,
    { updates },
  );
};
